import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ICoverage } from 'src/app/state/coverages/coverages.models';
import { environment } from 'src/environments/environment';
import { IGetCoberturasResponse } from '../../interfaces/response/IGetCoberturasResponse';

@Injectable({
  providedIn: 'root'
})
export class CoberturasService {
  baseUrl = `${environment.baseUrl}`;
  apiUrl = `${environment.ApiProducto}`;
  url: string;

  constructor(private http: HttpClient) {
    this.url = this.baseUrl + this.apiUrl;
  }


  /**
   * @param idProductoOperativa   Id of the product
   */ 

  getCoberturasObligatorias(idProductoOperativa): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}${this.apiUrl}/GetCoveragesRequiredbyIdProductOperation/${idProductoOperativa}`);
  }
  

  /**
   * @param idProductoOperativa Id of the product GetCoveragesOptionalsbyIdQuotation
   */

  getCoberturasOpcionales(idCotizacion: number, proxy: boolean = false, includePackages: number[] = [1,2,3]): Observable<ICoverage[]> {
    const query_params = { includePackages: includePackages };
    const params = this.add_params(query_params);

    let url = `${this.baseUrl}${this.apiUrl}/GetCoveragesOptionalsbyIdQuotation/${idCotizacion}`;
   // if(proxy) url = `${environment.proxy.root}/${environment.proxy.api}/${this.apiUrl}/Coberturas/${idCotizacion}/opcionales/catalogo`;

    return this.http.get<IGetCoberturasResponse>(url, params).pipe(
      map(resp => resp.data || [])
    );
  }

  /**
   * @param idProductoOperativa Id of the product
   */

   getCoberturasObligatoriasByIdCotizacion(idCotizacion: number, proxy: boolean = false, includePackages: number[] = [1,2,3]): Observable<ICoverage[]> {
    const query_params = { includePackages: includePackages };
    const params = this.add_params(query_params);

    let url = `${this.baseUrl}${this.apiUrl}/GetCoveragesRequiredbyIdQuotation/${idCotizacion}`;
    //if(proxy) url = `${environment.proxy.root}/${environment.proxy.api}/${this.apiUrl}/Coberturas/${idCotizacion}/ObligatoriasPorCotizacion/catalogo`; 

    return this.http.get<IGetCoberturasResponse>(url, params).pipe(
      map(resp => resp.data || [])
    );
  }

  /**
     * Return an object with the params defined
     * @param params The params to be inserted in the query
     * @returns An object to be passed to the the request's params
     */
   private add_params(params: any): { params: HttpParams } {
    return {
        params: new HttpParams({
            fromObject: {
                ...params
            }
        })
    };
}

/**
 * 
 * @param idPantalla id of the screen
 * @param idInfo id of the section info
 */

  getCoberturasDetalle(idPantalla, idInfo): Observable<any> {
    const params = { params: new HttpParams({ fromObject: { idPantallaInfo: idInfo } }) };
    return this.http.get<any>(`${this.baseUrl}${this.apiUrl}/GetCoveragesDetailsbyScreen/${idPantalla}`, params);
  }
}
